import { PreVettingStep2Screen } from "@/features/vendor/pre-vetting";

export default PreVettingStep2Screen;
